import React, { useState, useEffect } from 'react';
import {
  CDBSidebar,
  CDBSidebarContent,
  CDBSidebarFooter,
  CDBSidebarHeader,
  CDBSidebarMenu,
  CDBSidebarMenuItem,
} from 'cdbreact';
import { NavLink, useLocation } from 'react-router-dom';
import authStorage from '../../Auth/Storage';
import { useNavigate } from "react-router-dom";

function Navbar() {
  const history = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState('');

  const handleLogout = () => {
    authStorage.removeUser();
    history("/login");
    window.location.reload();
  };

  const closeMobileSidebar = () => {
    const sidebar = document.getElementById('sidebar');
    const overlay = document.querySelector('.sidebar-overlay');
    
    if (window.innerWidth <= 768) {
      if (sidebar) {
        sidebar.classList.remove('mobile-open');
      }
      if (overlay) {
        overlay.classList.remove('active');
      }
    }
  };

  function getUsername() {
    const userName = authStorage.getUser();
    if (!userName) return;

    const { username } = JSON.parse(userName);
    setUsername(username);
  }

  useEffect(() => {
    getUsername();
  }, []);

  const menuItems = [
    { path: '/', icon: 'bi-speedometer2', label: 'Dashboard', exact: true },
    { path: '/task', icon: 'bi-box-seam', label: 'Product Management' },
    { path: '/ClientList', icon: 'bi-signpost', label: 'Borders Management' },
    { path: '/Service', icon: 'bi-people', label: 'Traders Management' },
    { path: '/market-itelligency-List', icon: 'bi-graph-up', label: 'Market Intelligence' },
    { path: '/order-list', icon: 'bi-cart-check', label: 'Order Management' },
    { path: '/complain-list', icon: 'bi-exclamation-triangle', label: 'Complaints & Issues' },
  ];

  return (
    <div id="sidebar" style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <CDBSidebar textColor="#fff" backgroundColor="transparent" className="h-100">
        {/* Header */}
        <CDBSidebarHeader className="border-bottom border-light border-opacity-25 py-4">
          <div className="d-flex align-items-center">
            <div className="bg-white bg-opacity-20 rounded-circle d-flex align-items-center justify-content-center me-3" style={{width: '40px', height: '40px'}}>
              <i className="bi bi-building text-white fs-5"></i>
            </div>
            <div>
              <h5 className="mb-0 fw-bold text-white">EABC TRADERS</h5>
              <small className="text-white text-opacity-75">Management System</small>
            </div>
          </div>
        </CDBSidebarHeader>

        {/* Content */}
        <CDBSidebarContent className="sidebar-content py-3" style={{ overflowY: 'auto', flex: 1 }}>
          {/* User Info Section */}
          <div className="px-3 mb-4">
            <div className="bg-white bg-opacity-10 rounded-3 p-3">
              <div className="d-flex align-items-center">
                <div className="bg-white bg-opacity-20 rounded-circle d-flex align-items-center justify-content-center me-3" style={{width: '32px', height: '32px'}}>
                  <i className="bi bi-person-fill text-white"></i>
                </div>
                <div className="flex-grow-1 min-w-0">
                  <div className="fw-semibold text-white small text-truncate">
                    Welcome back!
                  </div>
                  <div className="text-white text-opacity-75 text-truncate" style={{fontSize: '12px'}}>
                    {username || 'Administrator'}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Menu */}
          <CDBSidebarMenu>
            {menuItems.map((item, index) => (
              <div key={index} className="nav-menu-item">
                <NavLink 
                  to={item.path}
                  className={({ isActive }) => 
                    `text-decoration-none d-block px-3 py-2 text-white ${
                      isActive ? 'active' : ''
                    }`
                  }
                  onClick={closeMobileSidebar}
                  end={item.exact}
                >
                  <div className="d-flex align-items-center">
                    <i className={`bi ${item.icon} me-3`} style={{fontSize: '18px'}}></i>
                    <span className="fw-medium">{item.label}</span>
                  </div>
                </NavLink>
              </div>
            ))}
          </CDBSidebarMenu>
        </CDBSidebarContent>

        {/* Footer */}
        <CDBSidebarFooter className="border-top border-light border-opacity-25 py-3">
          <div className="px-3">
            <button
              onClick={handleLogout}
              className="btn btn-outline-light btn-sm w-100 d-flex align-items-center justify-content-center"
              style={{ border: '1px solid rgba(255, 255, 255, 0.3)' }}
            >
              <i className="bi bi-box-arrow-right me-2"></i>
              Sign Out
            </button>
          </div>
          <div className="text-center mt-3">
            <small className="text-white text-opacity-50">
              © 2024 EABC Traders
            </small>
          </div>
        </CDBSidebarFooter>
      </CDBSidebar>
    </div>
  );
}

export default Navbar;